import {Helmet} from '@dr.pogodin/react-helmet';

import {useParams} from 'react-router-dom';

import {isNil} from 'ramda';

import {useGetTransferOrderVariantQuery} from '@dms/api/warehouse';
import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsTemplate, SettingsTemplateHeader} from '@dms/settings/shared';

import {TransferOrderVariantsDetailForm} from './components/TransferOrderVariantsDetailForm';

export function WarehouseTransferOrderVariantsDetail() {
  const {id} = useParams();

  const isDraft = isNil(id);

  const transferOrderVariantQuery = useGetTransferOrderVariantQuery(
    {transferOrderVariantId: id as string},
    {skip: isNil(id)}
  );

  const header: SettingsTemplateHeader = {
    title: isDraft
      ? i18n.t('entity.warehouse.actions.newTransferOrderVariant')
      : (transferOrderVariantQuery.data?.name ?? ''),
    breadcrumbs: [
      {
        label: i18n.t('entity.warehouse.labels.transferOrderVariants'),
        href: settingsRoutes.warehousesTransferOrderVariants,
      },
    ],
  };

  return (
    <>
      <Helmet title={i18n.t('entity.warehouse.labels.transferOrderVariantDetail')} />
      <SettingsTemplate
        header={header}
        isLoading={transferOrderVariantQuery.isLoading}
        isError={transferOrderVariantQuery.isError}
        data-testid={testIds.settings.warehousesTransferOrderVariantsDetail('template')}
      >
        <TransferOrderVariantsDetailForm
          isDraft={isDraft}
          transferOrderVariant={transferOrderVariantQuery.data}
          data-testid={testIds.settings.warehousesTransferOrderVariantsDetail('form')}
        />
      </SettingsTemplate>
    </>
  );
}
